export const cardapioFilterFields = [
  {
    name: "nome",
    label: "Nome do sabor",
    placeholder: "Buscar por nome do sabor...",
    type: "text" as const,
  },
  {
    name: "ingrediente",
    label: "Ingrediente",
    placeholder: "Buscar por ingrediente...",
    type: "text" as const,
  },
];
